module.exports = "/assets/data/7ff70214646ec576a33f8543b4ed77eb-YO8.data.json";